import { __extends } from "tslib";
import { DecreaseStreamRetentionPeriodInput } from "../models/index";
import { deserializeAws_json1_1DecreaseStreamRetentionPeriodCommand, serializeAws_json1_1DecreaseStreamRetentionPeriodCommand, } from "../protocols/Aws_json1_1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var DecreaseStreamRetentionPeriodCommand = /** @class */ (function (_super) {
    __extends(DecreaseStreamRetentionPeriodCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function DecreaseStreamRetentionPeriodCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    DecreaseStreamRetentionPeriodCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var handlerExecutionContext = {
            logger: logger,
            inputFilterSensitiveLog: DecreaseStreamRetentionPeriodInput.filterSensitiveLog,
            outputFilterSensitiveLog: function (output) { return output; },
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    DecreaseStreamRetentionPeriodCommand.prototype.serialize = function (input, context) {
        return serializeAws_json1_1DecreaseStreamRetentionPeriodCommand(input, context);
    };
    DecreaseStreamRetentionPeriodCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_json1_1DecreaseStreamRetentionPeriodCommand(output, context);
    };
    return DecreaseStreamRetentionPeriodCommand;
}($Command));
export { DecreaseStreamRetentionPeriodCommand };
//# sourceMappingURL=DecreaseStreamRetentionPeriodCommand.js.map